import React from "react";
import { Card, Tabs } from "antd";
import SectionTitle from "../SectionTitle/SectionTitle";
import { frozenYogurtProducts, iceCreamProducts } from "../../data/products";
import "./ProductCatalog.css";

function ProductGrid({ products, disabled = false }) {
  return (
    <div className="product-catalog__grid">
      {products.map((product) => (
        <Card
          key={product.name}
          className={`product-catalog__card ${
            disabled ? "product-catalog__card--disabled" : ""
          }`}
        >
          {disabled && (
            <div className="product-catalog__coming-soon">
              <h4>EM BREVE</h4>
              <p>Novos sabores chegando</p>
            </div>
          )}

          <div className="product-catalog__image">
            <img src={product.image} alt={product.name} />
          </div>

          <span>{product.category}</span>
          <h3>{product.name}</h3>
          <p>{product.description}</p>
        </Card>
      ))}
    </div>
  );
}

function ProductCatalog() {
  const items = [
    {
      key: "1",
      label: "Linha Ginza",
      children: (
        <>
          <div className="product-catalog__info">
            <strong>Modo de preparo:</strong> 1kg de Dry Mix + 4 litros de leite integral.
            Bater por 5 minutos no liquidificador e colocar na máquina soft.
          </div>

          <ProductGrid products={frozenYogurtProducts} />
        </>
      ),
    },
    {
      key: "2",
      label: "Sorvetes 10L",
      children: (
        <>
          <div className="product-catalog__info">
            <strong>Aplicação:</strong> ideal para sobremesas, combos, taças,
            acompanhamentos e cardápios de alta saída.
          </div>

          <ProductGrid products={iceCreamProducts} disabled />
        </>
      ),
    },
  ];

  return (
    <section className="product-catalog section" id="produtos">
      <div className="container">
        <SectionTitle
          center
          eyebrow="Catálogo"
          title="Produtos para transformar o pós-refeição em venda"
          description="Organizamos os produtos por linha para facilitar a escolha e mostrar o potencial de uso no restaurante."
        />

        <Tabs
          centered
          defaultActiveKey="1"
          items={items}
          className="product-catalog__tabs"
        />
      </div>
    </section>
  );
}

export default ProductCatalog;